<template>
  <el-container>
    <el-header class="HomeHeader">
      <div class="HomeHeader-content">
        <img class="HomeHeader-logo" :src="BLWIcon">
        <div class="HomeHeader-bg">
          <div class="HomeHeader-bg-div" @click="openUrl(data.url)" v-for="(data, index) in officialsites" :key="index">{{data.name}}</div>
        </div>
        <el-button type="danger" @click="onLoginClick" round> 商家登录 </el-button>
      </div>
    </el-header>
    <el-main class="HomeMain" style="margin-top:60px">
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
import BLWIcon from "@/assets/img/home/logo_blw.png"
export default {
  name: 'Home',
  components: {
    
  },
  data() {
    return {
      activeIndex2: '1',
      BLWIcon: BLWIcon,
      officialsites: [
        {
          name: "震旦官网",
          url: this.$store.state.zdUrl,
        },
        {
          name: "宝物志",
          url: this.$store.state.bwzUrl,
        },
        {
          name: "宝来客",
          url: this.$store.state.blkUrl,
        },
      ],
    }
  },
  methods: {
    onLoginClick() {
      window.open("https://server.zhendantech.com");
    },
    openUrl(url) {
      window.open(url);
    }
  }
}
</script>
<style lang="scss" scoped>
  .HomeHeader{
    background: #fff;
    width:100%;
    height: 70px;
    position: fixed;
    top:0;
    z-index: 9999;
    &-content{
      display: flex;
      align-items: center;
      justify-content: space-between;
      color:#fff;
      width:1300px;
      padding:0 100px;
      margin:0 auto
    }
    &-logo{
      width: 166px;
      height: 50px;
      margin-top: 5px;
    }
    &-bg {
      width: 400px;
      margin-left: 480px;
      display: flex;
      &-div {
        margin-left: 80px;
        font-size: 16px;
        font-weight: 400;
        color: #3D2F2F;
        text-align: right;
      }
      &-div:hover {
        cursor: pointer;
        border-bottom: outset 1px #3D2F2F;
      }
    }
  }
  .HomeMain{
    padding:0;
    background: $back-color;
  }
  .el-image{
    display: block !important;
    
  }
  .el-main{
    overflow:visible
  }
  .el-header {
    padding:0
  }
  .el-menu-item{
    margin:0 20px !important
  }
  .el-menu.el-menu--horizontal{
    border-bottom: 0;
  }
</style>
